import React, { useState, useRef, useEffect, useMemo } from 'react'
import classes from "./SingleDeviceUsersTableLayout.module.css"
import swapSettings from "../../../assets/portalAssets/Swap arrow.png";
import RemoveUser from "../../../assets/portalAssets/trash-bin.png";
import Pill_Widget from '../Widgets/Pill_Widget';
import TaskTable from './TaskTable'
import { DateTime } from 'luxon'
import Verified_Icon from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Table Icons/__Tick On.svg";
import NotVerified_Icon from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Table Icons/__Tick Off.svg";
import DropdownList from "../../UI/Cards/DropdownList";
import SettingsCog from "../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gear.png";
import InviteUserForm from "../../forms/InviteUserForm";
import Button1 from "../../UI/Button/Button1";
import ComponentCard from "../../UI/Cards/ComponentCard/ComponentCard";
import Input from '../../CustomDropDown/Input/Input';
import { changeRole, removeUser, inviteUser, suspendUser, switchInstallerMode } from "../../../Api Methods/Api";
import { useLoaderData, useNavigate } from 'react-router-dom';
import SearchBar from '../../PowerSearch/SearchBar';
import BasicTable from '../../Table/Table/Table';
import { authActions } from '../../../store/auth-Slice';
import { useDispatch, useSelector } from 'react-redux';
import Input1 from '../Inputs/Input1';
import CopyUserToAnotherDeviceForm from '../../forms/CopyUserToAnotherDeviceForm';
import SearchbarSmall from '../Inputs/SearchbarSmall';
import ExportExcel from '../../ExcelExport/ExcelExport';
import UseDateFormat from '../../hooks/UseDateFormat';
import { Hidden } from '@mui/material';
import check from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import cross from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cross.png'
import DataManager from '../../../hooks/DataManager';
import Button2 from '../Button/Button2';
import InviteExistingUserForm from '../../forms/InviteExistingUserForm';
import { Checkbox } from 'primereact/checkbox';
import MassAddUserForm from '../../forms/MassAddUserForm';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import suspendIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/suspended.png'
import { ro } from 'date-fns/locale';
import InviteAdminForm from '../../forms/InviteAdminForm';
import { format } from 'date-fns';

const SingleDeviceUsersTableLayout = ({ SiteDeviceUserList, setModalTitle, setModalComponent, deviceTag, apiData, deviceId, userID, userRole, userEmail, DeviceName, HandleShowModal, HandleCloseModal, DeviceUUID, companyName, HandleDeviceUserList, scheduleOnly }) => {

    console.log(SiteDeviceUserList)
    console.log(companyName)
    const [openDropdownRowId, setOpenDropdownRowId] = useState(null);
    const [success, setSuccess] = useState("")
    const [filtering, setFiltering] = useState('');
    const singleDeviceHeaderData = useSelector(state => state.service.singleDeviceHeaderData);
    const key = singleDeviceHeaderData.key;
    const [exportData, setExportData] = useState();
    const dataManager = new DataManager();
    const [checkedUsers, setCheckedUsers] = useState([]);
    const [selectAllUsers, setSelectAllUsers] = useState(false)
    const [showRemoveUsers, setShowRemoveUsers] = useState(false)

    const [userAdded, setUserAdded] = useState(false)
    const [failedToAdd, setFailedToAdd] = useState(false)
    const [failMessage, setFailMessage] = useState("")

    const [modalMessageSuccess, setModalMessageSuccess] = useState("")
    const [modalMessageFail, setModalMessageFail] = useState("")
    const [isCompleteModalOpen, setIsCompleteModalOpen] = useState(false)

    const [pageSize, setPageSize] = useState(20)

    const handleSettingsClick = (rowId) => {
        if (openDropdownRowId === rowId) {
            setOpenDropdownRowId(null);
        } else {
            setOpenDropdownRowId(rowId);
        }
    };

    const dropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownRowId(null);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const HandleUipiodOnClick = async (rowData) => {

        const userID = rowData.id
        const userName = rowData.fullName

        dataManager.setItem('clickedUserID', userID);
        localStorage.setItem('ClickedUserFullName', userName);
        dispatch(authActions.setClickedUserDetails({ userID, userName }))
        dataManager.setItem('clickedUserObj', rowData);

        navigate("/Dashboard/Users/UserSites");
    }

    useEffect(() => {
        if (success !== ""){
            if (success){
                setModalComponent(
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <img className={classes.ModalIcon} src={check}>
                        </img>
                        <br></br>
                        <br></br>
                        <div>
                            <h3 style={{ textAlign: "center", color:"#858585"}}>Users copied successfully</h3>
                        </div>   
                        <br></br>
                        <br></br>
                        <div>
                        <br></br>
                        <Button1 onClick={HandleCloseModal} style={{width:"100%"}}>Close</Button1>
                        </div>
                    </div>
                )
                setSuccess("")
            } else {
                setModalComponent(
                    <div>
                         <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <img className={classes.ModalIcon} src={cross}>
                        </img>
                        <br></br>
                        <br></br>
                        <div>
                            <h3 style={{ textAlign: "center", color:"#858585"}}>Failed to copy users</h3>
                        </div>   
                        <br></br>
                        <br></br>
                        <div>
                        <br></br>
                        <Button1 onClick={HandleCloseModal} style={{width:"100%"}}>Close</Button1>
                        </div>
                    </div>
                    </div>
                )   
                setSuccess("")
            }
        }
    }, [success])

    const HandleUserChecked = (userObject) => {
        console.log(userObject)

        setCheckedUsers(prevCheckedUsers => {
            const exists = prevCheckedUsers.some(user => user.id === userObject.id)
            if (exists){
                return prevCheckedUsers.filter(user => user.id !== userObject.id)
            } else {
                return [...prevCheckedUsers, userObject]
            }
        })
    }

    const HandleSelectAllUsers = () => {
        if (selectAllUsers){
            setSelectAllUsers(false)
            setCheckedUsers([])
        } else {
            setSelectAllUsers(true)
            setCheckedUsers(SiteDeviceUserList.data)
        }
    }

    useEffect(() => {
        console.log(checkedUsers)
        if (checkedUsers.length > 0){
            //show remove button
            setShowRemoveUsers(true)
        } else {
            //hide it 
            setShowRemoveUsers(false)
        }
    }, [checkedUsers])

    const HandleRemoveUsers = () => {
        Promise.all(
            checkedUsers.map(user =>
                removeUser(apiData, deviceId, DeviceUUID, userID, user.id, dispatch)
            )
        ).then(() => {
            HandleDeviceUserList();
            showSuccess("Access revoked successfully")
            setShowRemoveUsers(false)
            setSelectAllUsers(false)
            setCheckedUsers([]) // Show your success modal/popup
        }).catch(error => {
            showError(`Failed to remove one or more users. \n${error}`);
        });
    };

    const HandleSuspendUsers = () => {
        Promise.all(
            checkedUsers.map(user => 
                suspendUser(apiData, user.id, user.suspended == 1 ? 0 : 1, deviceId)
                
            )
        ).then(() => {
            HandleDeviceUserList();
            showSuccess(`Action completed successfully`);
            setCheckedUsers([]) 
        })
    }

    const handleSelectNewUserRole = () => {

        
        setModalTitle("Select new role")
        setModalComponent(
           <div className={classes.containerPopup}>
                    <Button2
                        style={{ 
                            minWidth: "350px", 
                            minHeight: "50px", 
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center"
                        }}    
                        onClick={() => HandleChangeRole("user")}>
                        <h4 style={{margin:"0px"}}>{"App standard user"}</h4>
                    </Button2>
               
                    <Button2 
                        style={{ 
                            minWidth: "350px", 
                            minHeight: "50px", 
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center"
                        }}    
                        onClick={() => HandleChangeRole("manager")}>
                        <h4 style={{margin:"0px"}}>{"App manager"}</h4>
                    </Button2>
               
                    <Button2 
                        style={{ 
                            minWidth: "350px", 
                            minHeight: "50px", 
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center"
                        }}    
                        onClick={() => HandleChangeRole("manager_plus")}>
                        <h4 style={{margin:"0px"}}>Manager plus</h4>
                    </Button2>
                </div>
            )
        HandleShowModal();
    }


    const HandleChangeRole = (role) => {
        //show popup
        Promise.all(
            checkedUsers.map(user => 
                changeRole(apiData, deviceId, userID, role, user.id, DeviceUUID, dispatch )
            )
        ).then(() => {
            HandleDeviceUserList();
            showSuccess("Roles updated successfully")
            setCheckedUsers([]) 
        })
    }

    const HandleAppAdmin = () => {
        Promise.all(
            checkedUsers.map(user => 
                switchInstallerMode(apiData, user.id, "INSTALLER")
            )
        ).then (() => {
            HandleDeviceUserList();
            showSuccess("Action completed successfully")
            setCheckedUsers([]) 

        })
    }

    const HandleDisableAppAdmin = () => {
        Promise.all(
            checkedUsers.map(user => 
                switchInstallerMode(apiData, user.id, "")
            )
        ).then (() => {
            HandleDeviceUserList();
            showSuccess("Action completed successfully")
            setCheckedUsers([]) 

        })
    }

    const showSuccess = (message) => {
        setModalTitle("Success")
        setModalComponent(
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <img className={classes.ModalIcon} src={check}>
            </img>
            <br></br>
            <br></br>
            <div>
                <h3 style={{ textAlign: "center", color:"#858585"}}>{message}</h3>
            </div>   
            <br></br>
            <br></br>
            <div>
              <br></br>
              <Button1 onClick={HandleCloseModal} style={{width:"100%"}}>Close</Button1>
            </div>
          </div>
        )

        HandleShowModal();
    }

    useEffect(() => {
        console.log(userAdded)
        if (userAdded){
            showSuccess("User added successfully");
            setUserAdded(false);
        }
    }, [userAdded])

    useEffect(() => {
        console.log(failedToAdd)
    if (failedToAdd){
        showError();
        setFailedToAdd(false);
    }
    }, [failedToAdd])

    const showError = () => {
        setModalTitle("Error")
        setModalComponent(
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <img className={classes.ModalIcon} src={cross}>
            </img>
            <br></br>
            <br></br>
            <div>
                <h3 style={{ textAlign: "center", color:"#858585"}}>{failMessage}</h3>
            </div>   
            <br></br>
            <br></br>
            <div>
              <br></br>
              <Button1 onClick={HandleCloseModal} style={{width:"100%"}}>Close</Button1>
            </div>
          </div>
        )

        HandleShowModal();
    }

    const columns = [
        {
            id: 'name', 
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <div style={{ marginRight: "10px" }}>
                        <Checkbox 
                            onChange={e => HandleSelectAllUsers()} 
                            checked={selectAllUsers}
                        />
                    </div>
                    <h3>Name</h3>
                </div>
            ),
            accessorKey: 'fullName',
            cell: (row) => {
                return (
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ marginRight: "10px" }}>
                            <Checkbox 
                                onChange={e => HandleUserChecked(row.row.original)} 
                                checked={checkedUsers.some((item) => item.id === row.row.original.id)}
                            />
                        </div>
                        <div
                            onClick={() => HandleUipiodOnClick(row.row.original)}
                            className={classes.tableValueText}
                        >
                            {row.row.original.fullName}
                        </div>
                    </div>
                )
            }
            // cell: (props) => <p> {props.getValue()}</p>
        },
        {

            id: 'email', 
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Email Address</h3>
                </div>
            ),
            accessorKey: 'email',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original)} className={classes.tableValueText}>
                        {row.row.original.email}
                    </div>
                )
            }
        },
        {
            id: 'role',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                  <h3>Role</h3>
              </div>
            ),
            accessorKey: 'role',
            cell: (props) => {
                let role = props.getValue() ? (props.getValue().charAt(0).toUpperCase() + props.getValue().slice(1)) : "";
                let installer = props.row.original.portalAccess;
                let managerPlus = props.row.original.liveViewAccess;
                console.log(props.row.original)
                if (installer == "INSTALLER"){
                    //App Admin
                    installer = "App admin"
                } else if (installer !== "INSTALLER" && installer !== "" && installer ){
                    installer = "Portal admin"
                }
                return (
                    <div style={{ display: "flex", gap: "10px" }}>
                        <Pill_Widget boolean={role == "User"} PillColor_IfTrue={"#d5d5d5"} PillColor_IfFalse={"#1e82d4"} text_IfTrue={"App standard user"} text_IfFalse={managerPlus == 0 ? "App manager" : "Manager Plus"} textColour_IfTrue={"#424242"} textColour_IfFalse={"rgb(255, 255, 255)"} className={classes.PillHeight}/>
                        {installer != "" && <Pill_Widget boolean={installer} PillColor_IfTrue={"black"} PillColor_IfFalse={"none"} text_IfTrue={installer} text_IfFalse={""} className={classes.PillHeight}/>}
                    </div>)
            }
        },
        // {header: "Account Added on", accessorFn: row => `${row.invitedBy} ${row.created}`},
        {
            id: 'invitedBy',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                  <h3>Invited by</h3>
              </div>
            ),
            accessorKey: 'invitedBy',
            cell: (row) => {
                let invitedBy = row.row.original.invitedBy;
                if (invitedBy == "") {
                    return (
                        <div className={classes.tableValueText}>
                            {"Added device using Site ID"}
                        </div>
                    )
                }
                return (
                    <div className={classes.tableValueText}>
                        {invitedBy}
                    </div>
                )
            }
        },
        {
            id: 'accountCreated',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                  <h3>Access</h3>
              </div>
            ),
            accessorKey: 'accessEnd',
            // cell: (props) => <p> {props.getValue()}</p>
            cell: (row) => {
                const accessEnd = row.row.original.accessEnd
                const accessStart = row.row.original.accessStart
                let accessEndFormatted = ""
                let accessStartFormatted = ""
                let suspended = row.row.original.suspended == 1

                if (accessEnd) {
                    accessEndFormatted = `Until: ${format(new Date(row.row.original.accessEnd), "MMM do, yyyy - HH:mm")}`
                }

                if (accessStart) {
                    accessStartFormatted = `Since: ${format(new Date(accessStart), "MMM do, yyyy - HH:mm")}`
                }
                return (
                    <div className={classes.tableValueText}>
                         { accessStartFormatted !== "" && <Pill_Widget 
                            boolean={accessStartFormatted !== ""} 
                            PillColor_IfTrue={"#ffffff00"} 
                            PillColor_IfFalse={""} 
                            text_IfTrue={accessStartFormatted} 
                            text_IfFalse={""} 
                            textColour_IfTrue={"#707070ff"} 
                            textColour_IfFalse={"rgb(255, 255, 255)"} 
                            className={classes.PillHeight}
                        />}
                        { accessEndFormatted !== "" && <Pill_Widget 
                            boolean={accessEndFormatted !== ""} 
                            PillColor_IfTrue={"#ee616a00"} 
                            PillColor_IfFalse={""} 
                            text_IfTrue={accessEndFormatted} 
                            text_IfFalse={""} 
                            textColour_IfTrue={"#707070ff"} 
                            textColour_IfFalse={"rgb(255, 255, 255)"} 
                            className={classes.PillHeight}
                        />}

                        <div style={{ display: "flex", gap: "10px" }}>
                        {((row.row.original.portalAccess == "" || row.row.original.portalAccess == null) && suspended) && 
                            <Pill_Widget 
                                boolean={row.row.original.suspended == 1} 
                                PillColor_IfTrue={"#e67a81"} 
                                PillColor_IfFalse={""} 
                                text_IfTrue={"Suspended"} 
                                text_IfFalse={""} 
                                textColour_IfTrue={"#FFFFFF"} 
                                textColour_IfFalse={"rgb(255, 255, 255)"} 
                                className={classes.PillHeight}
                            />
                        }
                        </div>
                    </div>
                )
            }
                
        },
        // {
        //     header: () => (
        //         <div className={classes.tableTitleText} title="Click to sort">
        //           <h3> </h3>
        //       </div>
        //     ),
        //     accessorKey: 'suspended',
        //     cell: (row) => {
        //         return (
        //             <div style={{ display: "flex", gap: "10px" }}>
        //                 { (row.row.original.suspended == 1 && (row.row.original.portalAccess == "" || row.row.original.portalAccess == null)) && <Pill_Widget boolean={row.row.original.suspended == 1} PillColor_IfTrue={"#e67a81"} PillColor_IfFalse={""} text_IfTrue={"Suspended"} text_IfFalse={""} textColour_IfTrue={"#FFFFFF"} textColour_IfFalse={"rgb(255, 255, 255)"} className={classes.PillHeight}/>}
        //             </div>)
        //     }
        // }
        // {
        //     id: 'verified',
        //     header: () => (
        //         <div className={classes.tableTitleText} title="Click to sort">
        //           <h3>Verified</h3>
        //       </div>
        //     ),
        //     accessorKey: 'verified',
        //     cell: (row) => {
        //         let verified_icon = null;
        //         if (row.row.original.verified == "yes") {
        //             verified_icon = Verified_Icon;
        //         } else {
        //             verified_icon = "";
        //         }
        //         return (
        //             <>
        //                 <img className={classes["VerifiedCell_image"]} src={verified_icon || ""} />
        //             </>
        //         )
        //     },
        //     hidden: true
        // },
        // {
        //     id: 'actions',
        //     cell: (row) => {
        //         const personName = row.row.original.fullName;
        //         const personEmail = row.row.original.email;
        //         return <input type="checkbox" id="scales" name="scales" unchecked onChange={() => console.log(personName, personEmail)} />
        //     }
        // },
    ]

    const showHiddenFeatures = true

    if (showHiddenFeatures) {
        columns.push({
            id: 'actions',
            cell: (row) => {
                let suspendTitle = "Suspend"
                if (row.row.original.suspended == 1){
                    suspendTitle = "Unsuspend"
                }
                const items = [
                    {
                        image: swapSettings,
                        "title": "Change users role"
                    },
                    {
                        image: RemoveUser,
                        "title": "Revoke access"
                    },
                    {
                        image: suspendIcon,
                        "title": `${suspendTitle} access`
                    }

                ];
                const ifSettingsCogIsClicked = openDropdownRowId === row.row.id
                return (
                    <DropdownList
                        item={row.row.id}
                        icon={SettingsCog}
                        onClick={handleSettingsClick}
                        ifSettingsCogIsClicked={ifSettingsCogIsClicked}
                        ref={dropdownRef}
                        title={"Actions"}
                        className={classes.container}
                        onUserActionClick={(userAction) =>
                            UserActionHandler(
                                row.row.original,
                                userAction,
                                row.row.original.role,
                                row.row.original.id
                            )}
                        listItems={items} />
                )
            }
        });
    }

    const HandleInviteUser = () => {
        setModalTitle("Invite user")
        
        setModalComponent(
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
              <Button label='New user' severity='success' onClick={handleInviteNewUser}/>
              <Button label='Existing user' severity='info' onClick={handleInviteExistingUser}/>
            </div>
          )

        HandleShowModal()
    }

    const HandleInviteAdmin = () => {
        setModalTitle("Invite admin")
        
        setModalComponent(
            <InviteAdminForm apiData={apiData} DeviceId={deviceId} userID={userID} userRole={userRole} userEmail={userEmail} DeviceName={DeviceName} label={""} dispatch={dispatch} HandleCloseModal={HandleCloseModal} HandleDeviceUserList={HandleDeviceUserList} companyName={companyName} setUserAdded={setUserAdded} setFailedToAdd={setFailedToAdd} setFailMessage={setFailMessage}/>
        )

        HandleShowModal()
    }

    const handleInviteNewUser = () => {
        setModalComponent(
            <InviteUserForm apiData={apiData} DeviceId={deviceId} userID={userID} userRole={userRole} userEmail={userEmail} DeviceName={DeviceName} label={"Please enter the email address below"} dispatch={dispatch} HandleCloseModal={HandleCloseModal} HandleDeviceUserList={HandleDeviceUserList} companyName={companyName} setUserAdded={setUserAdded} setFailedToAdd={setFailedToAdd} setFailMessage={setFailMessage}/>
        )

        HandleShowModal();
    }

    const handleInviteExistingUser = () => {
        setModalComponent(
            // <MassAddUserForm 
            //     apiData={apiData}
            //     sites={[{id: deviceId, tag: DeviceName, key: ""}]} //Temp - check if deviceName is correctly set before being passed to this class
            //     userID={userID}
            //     companyName={companyName}
            //     showAddingUsersModal={showAddingUsersModal}
            //     setModalMessageSuccess={setModalMessageSuccess}
            //     setModalMessageFail={setModalMessageFail}
            //     />
            <InviteExistingUserForm apiData={apiData} DeviceId={deviceId} userID={userID} userRole={userRole} userEmail={userEmail} DeviceName={DeviceName} label={""} dispatch={dispatch} HandleCloseModal={HandleCloseModal} HandleDeviceUserList={HandleDeviceUserList} companyName={companyName} setUserAdded={setUserAdded} setFailedToAdd={setFailedToAdd} setFailMessage={setFailMessage}/>
        )

        HandleShowModal();
    }

    const showAddingUsersModal = () => {
        setIsCompleteModalOpen(true)
    }

    const HandleCopyUsersToAnoterDevice = () => {
        setModalTitle("Copy users to another site")
        setModalComponent(<CopyUserToAnotherDeviceForm apiData={apiData} label={"Please enter the Site ID & name of the site below"} submitButtonText={"Copy"} processFunctionParamaters={{ apiData, deviceId, userID, DeviceName }} HandleCloseModal={setOpenDropdownRowId} dispatch={dispatch} success={success} setSuccess={setSuccess} />)
        HandleShowModal()
    }

    const UserActionHandler = (row, userAction, role, userIDToChange) => {
        if (role == "manager") {
            role = "user"
        } else if (role = "user") {
            role = "manager";
        }
        let suspend = 1

        console.log(row)

        if (row.suspended == 1){
            suspend = 0
        } else {
            suspend = 1
        }

        switch (userAction) {
            case 'Change users role':
                const ChangeRole = async () => {
                    const responseData = await changeRole(apiData, deviceId, userID, role, userIDToChange, DeviceUUID, dispatch);
                    if (responseData.success) {
                        setOpenDropdownRowId(null);
                        HandleDeviceUserList();
                    }
                }
                ChangeRole();
                break;
            case 'Revoke access':
                removeUser(apiData, deviceId, DeviceUUID, userID, userIDToChange, dispatch).then((responseData) => {
                    if (responseData) {
                        setOpenDropdownRowId(null);
                        HandleDeviceUserList();
                        showSuccess("Access revoked successfully")
                    }
                })
                break;
            case 'Suspend access': 
            case 'Unsuspend access':
                suspendUser(apiData, userIDToChange, suspend, deviceId).then((responseData) => {
                    if (responseData) {
                        setOpenDropdownRowId(null);
                        HandleDeviceUserList();
                        showSuccess("Access changed successfully")
                    }
                })
                break;
            default:
                console.warn('Invalid option:', userAction);
        }
    }

    const exportFormatFunction = (event) => {
        return {
            "Name": event.fullName,
            "Email": event.email,
            "Role": event.portalAccess != "" ? event.role + " Installer" : event.role,
            "Invited By": event.invitedBy,
            "Last Logged In": UseDateFormat(event.lastLoggedIn),
            "Account Created": UseDateFormat(event.created)
        };
    };

    const hideCompleteAddModal = () => {
        setIsCompleteModalOpen(false)
    }

    const HandleLoadMore = () => {
        setPageSize(pageSize + 20)
    }

    const dropdownOptions = useMemo(() => {
        const allSuspended = checkedUsers.every(user => user.suspended == 1);
        const suspendLabel = allSuspended ? "Unsuspend access" : "Suspend access";

        const allAdmin = checkedUsers.every(user => user.portalAccess != "")
        const adminLabel = allAdmin ? "Disable admin" : "Enable admin"
        const options = [
            "Revoke access",
            suspendLabel,
            "Change role",
            adminLabel
        ];
        return options;
    }, [checkedUsers]);

    const setSelectedAction = (e) => {
        switch (e) {
            case "Revoke access" : 
                HandleRemoveUsers()
                break;
            case "Suspend access" :
                HandleSuspendUsers();
                break;
            case "Unsuspend access" :
                HandleSuspendUsers();
                break;
            case "Change role" :
                handleSelectNewUserRole();
                break;
            case "Enable admin" :
                HandleAppAdmin();
                break;
            case "Disable admin" :
                HandleDisableAppAdmin();
                break;
        }
    }

    return (    
         <>
        <div className="card flex justify-content-center">
            { isCompleteModalOpen && (<Dialog header="Adding users..." visible={isCompleteModalOpen} style={{ width: '50vw' }} onHide={() => { if (!isCompleteModalOpen) return; setIsCompleteModalOpen(false); }}>
            <div className="flex flex-col items-center justify-center">
                {/* white-space:pre-line shows each “\n” on its own line */}
                <h3 style={{ whiteSpace: "pre-line", color: "#858585", textAlign: "center" }}>
                {modalMessageSuccess || ""}
                </h3>

                <h3 style={{ whiteSpace: "pre-line", color: "#858585", textAlign: "center" }}>
                {modalMessageFail || ""}
                </h3>

                <br />
                <Button1 style={{ width: "100%" }} onClick={hideCompleteAddModal}>
                Close
                </Button1>
            </div>
            </Dialog>)}
        </div>

        <ComponentCard className={classes["table-container"]}>
            <div className={classes["button-container"]}>
                <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                    <SearchbarSmall
                        type="text"
                        placeholder={"Search Users..."}
                        value={filtering}
                        onChange={(e) => setFiltering(e.target.value)}
                        onClear={() => setFiltering("")}
                    />
                    {showRemoveUsers && 
                        <Dropdown 
                            placeholder={"Select an action"} 
                            options={dropdownOptions}
                            onChange={(e) => setSelectedAction(e.value)}
                            />}
                </div>
                <div style={{ display: "flex", gap: "20px" }}>
                    {showHiddenFeatures && <div style={{ display: "flex", gap: "20px" }}>
                        {/* {showRemoveUsers && <Button1 style={{color:"#fc0303", fontWeight:"500"}}onClick={HandleRemoveUsers}>Remove user(s)</Button1>} */}
                        

                        <Button1 onClick={() => scheduleOnly == 0 ? HandleInviteUser() : HandleInviteAdmin()}>{scheduleOnly == 0 ? "Invite user" : "Invite admin"}</Button1>
                        <Button1 onClick={HandleCopyUsersToAnoterDevice}> Copy all users to another site</Button1>
                    </div>}

                    <ExportExcel
                        excelData={exportData}
                        fileName={"IPIO Site: " + key + " Users"}
                        title={"IPIO Portal-Users: " + key}
                        colWidths={
                            [
                                { wch: 30 },
                                { wch: 30 },
                                { wch: 15 },
                                { wch: 30 },
                                { wch: 25 },
                                { wch: 25 },
                            ]
                        }
                    />
                </div>
            </div>
            <BasicTable data={SiteDeviceUserList.data} columns={columns} filtering={filtering} rowClick={false} ShowPagination={true} PageSize={pageSize} setPageSize={setPageSize} paginationOptions={[10, 20, 30]} setExportData={setExportData} exportFormatFunction={exportFormatFunction} />
            {SiteDeviceUserList.data.length > pageSize && <Button onClick={HandleLoadMore}>Load more</Button>}
        </ComponentCard >
        </>
    )
}

export default SingleDeviceUsersTableLayout